import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import './section.scss';

interface IToggleGroupProps {
  toggleValue: unknown;
  toggles: { label: string; value: string; icon: string | JSX.Element }[];
  onToggle: (newToggle: unknown) => void;
  style?: React.CSSProperties;
  customClass?: string;
}

export default function ToggleButtonGroupWithIcon({
  onToggle,
  toggleValue,
  toggles,
  style = {},
  customClass = ''
}: IToggleGroupProps) {
  return (
    <ToggleButtonGroup
      size='small'
      color='primary'
      value={toggleValue}
      exclusive
      onChange={(_event, currKPI) => {
        if (currKPI === null) {
          return;
        }
        onToggle(currKPI);
      }}
      className={customClass}
    >
      {toggles.map((toggle) => (
        <ToggleButton sx={{ padding: '7px 8px' }} value={toggle.value}>
          {toggle.icon}
          <div style={{ marginLeft: '4px' }}>{toggle.label}</div>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
